import { Component } from '@angular/core';
import { ConsentService ,Preferences } from '../core/services/consent.service';
import { AuthenticationService } from '../core/services/auth.service';

@Component({
  selector: 'app-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss']
})
export class CookieBannerComponent {

  prefs: Preferences;
  visible = false;

  constructor(private consent: ConsentService ,private authService:AuthenticationService) {
    // this.prefs = this.consent.getLocalPreferences();
    // this.visible = !this.consent.hasSeenBanner();
  }


ngOnInit() {
  this.prefs = this.consent.getLocalPreferences();

  // re-check from localStorage after login
  setTimeout(() => {
    this.visible = !this.consent.hasSeenBanner();
  }, 300);
}

  acceptAll() {
    this.prefs = { analytics: true, marketing: true };
    this.save();
  }

  rejectAll() {
    this.prefs = { analytics: false, marketing: false };
    this.save();
  }

  // save() {
  //   this.consent.saveLocalPreferences(this.prefs);
  //   this.consent.markBannerSeen();
  //   this.visible = false;
  // }
save() {
  console.log("Save clicked", this.prefs);

  // Read user from localStorage
  const clpUser = localStorage.getItem("clpUser");
  const userObj = clpUser ? JSON.parse(clpUser) : null;
  const userId = userObj?.uid ? String(userObj.uid) : undefined;

  const anonymousId = this.consent.getAnonymousId();

  this.consent.loadPreferences().subscribe((res: any) => {

    if (res?.code === 0) {
      // ADD
      this.consent.addPreferences(this.prefs, userId)
        .subscribe(() => {
          this.consent.markBannerSeen();
          this.visible = false;
        });

    } else {
      // UPDATE
      this.consent.updatePreferences(this.prefs, userId,anonymousId)
        .subscribe(() => {
          this.consent.markBannerSeen();
          this.visible = false;
        });
    }
  });
}


}
